import zhCn from "./zh_CN.js"
import enUs from "./en_US.js"

const i18n = {
  'en-US': {
    ...enUs

  },
  'zh-CN': {
    ...zhCn
  },
}

export default i18n

